import { css } from '@emotion/react';
import { useNavigate } from 'react-router';
import { Col, Content, Row, Title, Avatar, Button, Icon, colors } from 'common-components';
import { useAppTranslation } from '@hooks';
import { UserDataType } from '@pages/types';

type HeaderContributorPropsType = {
  userContributor: UserDataType
};

const HeaderContributor = function ({ userContributor }: HeaderContributorPropsType) {
  const navigate = useNavigate();
  const { translate } = useAppTranslation();

  const subtitle = [
    translate(`common.states.userRole.${userContributor.type}`),
    userContributor.email,
    userContributor.phone,
  ]
    .filter(Boolean)
    .join(' - ');

  return (
    <Content>
      <Row
        align={'middle'}
        wrap={false}
        css={css`
          margin: 24px 0;
          gap: 20px;
        `}
      >
        <Col>
          <Button
            size="sm"
            onClick={() => {
              navigate(-1);
            }}
          >
            <Icon icon="ArrowNarrowLeft" size={20} />
          </Button>
        </Col>
        <Avatar src={userContributor.urlAvatar} size="xl" />
        <Col>
          <Title preset="singlePageTitle" style={{ color: colors.gray700 }}>
            {`${userContributor.firstName} ${userContributor.lastName}`}
          </Title>
          {/* HIDE
           * <ContributorTag state="positive">TOP 20%</ContributorTag>
           * */}
          <Title preset="tablePageSubtitle">{subtitle}</Title>
        </Col>
      </Row>
    </Content>
  );
};

export default HeaderContributor;
